import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Local from "model/patrimonio/Local";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import EmprestimoPatrimonioService from "service/patrimonio/EmprestimoPatrimonioService";
import { converterData, converterDataHora } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";

const emprestimoPatrimonioService = new EmprestimoPatrimonioService();

export default function EmprestimoPatrimonioListagem() {
    const [pessoas, setPessoas] = useState<Pessoa[]>([]);

    useEffect(() => {
        emprestimoPatrimonioService.pessoas().then(lista => {
            setPessoas(lista);
        }).catch(err => {
            console.log(err)
        });
    },[]);


    const defaultFilters: DataTableFilterMeta = {
        pessoaEmprestada: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataEmprestimo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPrevistaDevolucao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }   
    }

    const pessoaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={pessoas} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="id,DESC" service={emprestimoPatrimonioService} urlService="/emprestimoPatrimonio" tituloPagina={'Empréstimos'} defaultFilters={defaultFilters} showClearFilterButton nome="emprestimoPatrimonio">
            <Column field="pessoaEmprestada.nome" header="Pessoa Emprestada" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="pessoaEmprestada"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement = {pessoaFilterTemplate}
                headerStyle={{ width: "15%" }} />
            <Column field="status" header="Status" body={(rowData)=>emprestimoPatrimonioService.getStatus(rowData.status)} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, emprestimoPatrimonioService.getListaStatusFilter())}
                headerStyle={{ width: "15%" }} />
            <Column field="dataEmprestimo" body={(rowData) => rowData.dataEmprestimo ? converterDataHora(rowData.dataEmprestimo) : ""} header="Data Empréstimo" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
            <Column field="dataPrevistaDevolucao" body={(rowData) => rowData.dataPrevistaDevolucao ? converterData(rowData.dataPrevistaDevolucao) : ""} header="Data Prevista para Devolução" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
        </BaseListagem>
    )
}